import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

const KEY = "ungrip_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(KEY);
    if (!saved) setVisible(true);
  }, []);

  const decide = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, ts: new Date().toISOString(), version: "1.0" }));
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "cookie_consent", consent: choice });
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 sm:max-w-md z-[60] bg-[#141414] border border-[#333] rounded-2xl p-5 shadow-2xl"
          data-testid="cookie-banner"
        >
          <p className="font-display font-black uppercase text-xl text-[#FFC20E]">Cookie & voglia</p>
          <p className="text-white/70 text-sm mt-2">
            Usiamo cookie tecnici e, con il tuo consenso, cookie di marketing. Leggi la{" "}
            <Link to="/cookie" className="underline text-[#FFC20E]">Cookie Policy</Link>.
          </p>
          <div className="mt-4 flex gap-2">
            <button
              onClick={() => decide("accepted")}
              className="flex-1 rounded-full bg-[#FFC20E] text-[#0C0C0C] font-display font-extrabold uppercase text-sm py-2.5 hover:scale-[1.02] transition-transform"
              data-testid="cookie-accept-button"
            >
              Accetta
            </button>
            <button
              onClick={() => decide("rejected")}
              className="flex-1 rounded-full border border-[#444] text-white font-display font-bold uppercase text-sm py-2.5 hover:border-[#FFC20E]"
              data-testid="cookie-reject-button"
            >
              Solo necessari
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
